module.exports = __webpack_public_path__ + "img/C6.e5b4728d.jpg";